<template>
  <div>
    <div class="breadcrumb-area  pos-relative w-100">
      <h1>Chi tiết ID phụ lục thuê</h1>
      <div class="btn-group float-right">
        <button v-show="info.statusRentalAppendix === 'WAITING_FOR_CONFIRM' && dataPermission.includes('CNPS_DEVICE_CONTRACT_KEY_REQUEST_ADJUSMENT')" class="f12 font-medium btn btn-outline-secondary" @click='requestUpdate'>
          Yêu cầu chình sửa
        </button>
        <button v-show="info.statusRentalAppendix === 'WAITING_FOR_CONFIRM' && dataPermission.includes('CNPS_DEVICE_CONTRACT_KEY_CONFIRM_RENT_APPENDIX')" class="f12 font-medium btn btn-outline-secondary" @click='confirmPolicy'>
          Xác nhận chính sách
        </button>
        <button v-show="info.statusRentalAppendix === 'REQUEST_ADJUSTMENT' && dataPermission.includes('CNPS_DEVICE_CONTRACT_KEY_POLICY_ADJUSTMENT')" class="f12 font-medium btn btn-outline-secondary" @click='updatePolicy'>
          Điều chỉnh chính sách
        </button>
      </div>
    </div>

    <b-card title="Chi tiết" class="b-t-1-869fb229">
      <div class="form-detail">
        <div class="form-group form-row">
          <label for="" class="col-sm-2 col-form-label">ID cho thuê<span class="float-right">:</span></label>
          <div class="col-sm-10">
            <p class="form-control-plaintext f12">{{ info.code }}</p>
          </div>
        </div>

        <div class="form-group form-row">
          <label for="" class="col-sm-2 col-form-label">Mã phụ lục<span class="float-right">:</span></label>
          <div class="col-sm-10">
            <p class="form-control-plaintext f12">{{ info.appendixCode }}</p>
          </div>
        </div>

        <div class="form-group form-row">
          <label for="" class="col-sm-2 col-form-label">Merchant<span class="float-right">:</span></label>
          <div class="col-sm-10">
            <p class="form-control-plaintext f12">{{ info.nameMc }}</p>
          </div>
        </div>

        <div class="form-group form-row">
          <label for="" class="col-sm-2 col-form-label">Vùng<span class="float-right">:</span></label>
          <div class="col-sm-10">
            <p class="form-control-plaintext f12">{{ info.region }}</p>
          </div>
        </div>

        <div class="form-group form-row">
          <label for="" class="col-sm-2 col-form-label">Chính sách<span class="float-right">:</span></label>
          <div class="col-sm-10">
            <p class="form-control-plaintext f12">{{ info.namePolicy }}</p>
          </div>
        </div>

        <div class="form-group form-row">
          <label for="" class="col-sm-2 col-form-label">Ngày bắt đầu thuê<span class="float-right">:</span></label>
          <div class="col-sm-10">
            <p class="form-control-plaintext f12">{{ info.startRentDate | formatDate }}</p>
          </div>
        </div>

        <div class="form-group form-row">
          <label for="" class="col-sm-2 col-form-label">Ngày hết hạn<span class="float-right">:</span></label>
          <div class="col-sm-10">
            <p class="form-control-plaintext f12">{{ info.expiredRentDate | formatDate }}</p>
          </div>
        </div>

        <div class="form-group form-row">
          <label for="" class="col-sm-2 col-form-label">Trạng thái<span class="float-right">:</span></label>
          <div class="col-sm-10">
            <p class="form-control-plaintext f12">{{ mappingStatus[info.status] }}</p>
          </div>
        </div>
      </div>
    </b-card>

    <b-card title="Lịch sử" class="py-0">
      <b-table
        sticky-header
        responsive
        hover
        :items="lists"
        :fields="fields"
        :fixed="true"
        :bordered="true"
      >
        <template #cell(action)="{ item }">
          {{ mappingAction[item.action] }}
        </template>
        <template #cell(createdDate)="{ item }">
          {{ item.createdDate ? formatDateFromLong(item.createdDate) : '' }}
        </template>
      </b-table>
    </b-card>
    <PopupConfirm :id="id" ref="popupConfirmRef" @success="onChangeData"/>
    <PopupUpdatePolicy :id="id" ref="popupUpdatePolicyRef" @success="onChangeData"/>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { DeviceService } from '@/services/device.service';
import { showMess } from "@/config/utils";
import PopupConfirm from './components/popupConfirm.vue';
import PopupUpdatePolicy from './components/popupUpdatePolicy.vue';
import moment from 'moment';

export default {
  name: 'RentDetail',
  components: {
    PopupConfirm,
    PopupUpdatePolicy,
  },
  data () {
    return {
      showLoading: false,
      id: '',
      info: {},
      lists: [],
      fields: [
        { key: 'emailUser', label: 'Email user' },
        { key: 'action', label: 'Hành động' },
        { key: 'content', label: 'Nội dung' },
        { key: 'createdDate', label: 'Thời gian' }
      ],
      mappingAction: {
        REQUEST_ADJUSTMENT: 'Yêu cầu điều chỉnh',
        WAITING_FOR_CONFIRM: 'Chờ xác nhận',
        CONFIRMED: 'Đã xác nhận',
        POLICY_ADJUSTMENT: 'Điều chỉnh chính sách',
      },
      mappingStatus: {
        ACTIVE: 'Hoạt động',
        INACTIVE: 'Không hoạt động',
      }
    }
  },

  computed: {
    ...mapGetters({
      dataPermission: 'role/dataPermission'
    }),
    formatDateFromLong () {
      return (value) => {
        return moment(value * 1000).format('DD/MM/YYYY');
      }
    }
  },

  created () {
    this.id = this.$route.params.id;
  },

  mounted () {
    this.loadData()
  },

  methods: {
    async loadData () {
      try {
        this.showLoading = true
        const res = await DeviceService.getRentDetail({
          id: this.id
        })
        if (res.code === 1000) {
          const { historyRentalAppendixList, ...info } = res.data;
          this.info = info;
          this.lists = historyRentalAppendixList;
        } else {
          showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
        }
      } catch (e) {
        this.showFailMx(e.message)
      } finally {
        this.showLoading = false
      }
    },

    onChangeData () {
      this.loadData()
    },
    requestUpdate () {
      this.$refs.popupConfirmRef.show(0)
    },
    confirmPolicy () {
      this.$refs.popupConfirmRef.show(1)
    },
    updatePolicy () {
      this.$refs.popupUpdatePolicyRef.show(this.info.idPolicy)
    },

  }
}
</script>

<style scoped>
</style>
